import { gql } from 'graphql-tag';

export const GET_VOLUMETRIC_PACK_UPLOAD_URL = gql`
    query getVolumetricPackUploadUrl($projectId: Float!, $scanName: String!) {
        getVolumetricPackUploadUrl(projectId: $projectId, scanName: $scanName) {
            uploadUrl
            s3Uri
        }
    }
`;

export const GET_VOLUMETRIC_PACK_MULTIPART_INFO = gql`
    query getVolumetricPackMultipartInfo($projectId: Float!, $scanName: String!, $numberOfParts: Float!) {
        getVolumetricPackMultipartInfo(projectId: $projectId, scanName: $scanName, numberOfParts: $numberOfParts) {
            filename
            uploadId
            parts {
                eTag
                partNumber
                signedUrl
            }
        }
    }
`;

export const COMPLETE_VOLUMETRIC_PACK_MULTIPART = gql`
    mutation completeVolumetricPackMultipart(
        $projectId: Float!
        $scanName: String!
        $uploadId: String!
        $eTags: String!
    ) {
        completeVolumetricPackMultipart(
            projectId: $projectId
            scanName: $scanName
            uploadId: $uploadId
            eTags: $eTags
        )
    }
`;

export const PROCESS_VOLUMETRIC_PACK = gql`
    mutation processVolumetricPack($projectId: Float!, $scanName: String!) {
        processVolumetricPack(projectId: $projectId, scanName: $scanName)
    }
`;

export const GET_VOLUMETRIC_PACK_FILE_URL = gql`
    query getVolumetricPackFileUrl($projectId: Float!, $scanName: String!, $filePath: String!) {
        getVolumetricPackFileUrl(projectId: $projectId, scanName: $scanName, filePath: $filePath)
    }
`;
